import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../primitives/Calendar/Month/components/Container.js';
import { Title } from '../../../primitives/Calendar/Month/components/Title.js';
export const Month = /*#__PURE__*/_styled(forwardRef(({
  title,
  children,
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    ...restProps,
    ref: ref,
    children: [_jsx(Title, {
      children: title
    }), children]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "epujl4y0"
} : {
  target: "epujl4y0",
  label: "Month"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1vbnRoLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9JIiwiZmlsZSI6Ik1vbnRoLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL0NhbGVuZGFyL01vbnRoL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IFRpdGxlIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9DYWxlbmRhci9Nb250aC9jb21wb25lbnRzL1RpdGxlLmpzJztcbmV4cG9ydCBjb25zdCBNb250aCA9IHN0eWxlZChmb3J3YXJkUmVmKCh7IHRpdGxlLCBjaGlsZHJlbiwgLi4ucmVzdFByb3BzIH0sIHJlZikgPT4ge1xuICAgIHJldHVybiAoX2pzeHMoQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgcmVmOiByZWYsIGNoaWxkcmVuOiBbX2pzeChUaXRsZSwgeyBjaGlsZHJlbjogdGl0bGUgfSksIGNoaWxkcmVuXSB9KSk7XG59KSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Nb250aC5qcy5tYXAiXX0= */");